import api from './client';

// Storage Management API - Organization storage management features
export const storageManagementAPI = {
  // Feature 1: Storage Warnings
  getStorageWarnings: () => api.get('/storage/warnings'),

  // Feature 2: Organization Deletion
  getDeletionPreview: () => api.get('/storage/deletion-preview'),
  deleteOrganization: (confirmText: string) =>
    api.delete('/storage/organization', { data: { confirmText } }),

  // Feature 3: Bulk File Deletion
  createBulkDeletionJob: (data: {
    deletionType: 'completion_files' | 'media_items';
    criteria: {
      olderThanDays?: number;
      userId?: number;
      minSizeBytes?: number;
      maxSizeBytes?: number;
      fileTypes?: string[];
    };
  }) => api.post('/storage/bulk-delete', data),
  getBulkDeletionJobStatus: (jobId: number) =>
    api.get(`/storage/bulk-delete/${jobId}`),

  // Feature 4: Retention Warnings (admin/cron)
  processRetentionWarnings: () => api.post('/storage/retention/process'),

  // Feature 5: Admin File Management
  getOrgFiles: (params?: {
    page?: number;
    limit?: number;
    userId?: number;
    minSize?: number;
    maxSize?: number;
    beforeDate?: string;
    afterDate?: string;
    sortBy?: 'created_at' | 'file_size' | 'file_name';
    sortOrder?: 'asc' | 'desc';
    search?: string;
    includeDeleted?: boolean;
  }) => api.get('/storage/files', { params }),
  getLargestFiles: (limit?: number) =>
    api.get('/storage/files/largest', { params: limit ? { limit } : undefined }),
  adminDeleteFile: (fileId: number) => api.delete(`/storage/files/${fileId}`),

  // Feature 6: Recycle Bin
  getRecycleBin: (params?: { page?: number; limit?: number }) =>
    api.get('/storage/recycle-bin', { params }),
  restoreFile: (fileId: number) => api.post(`/storage/recycle-bin/${fileId}/restore`),
  emptyRecycleBin: () => api.delete('/storage/recycle-bin'),

  // Feature 7: Retention Communication
  getRetentionInfo: () => api.get('/storage/retention'),

  // Feature 8: Storage Analytics
  getStorageAnalytics: (period?: '7d' | '30d' | '90d' | '1y') =>
    api.get('/storage/analytics', { params: period ? { period } : undefined }),
  createDailySnapshot: () => api.post('/storage/analytics/snapshot'),

  // Feature 9: Storage Intelligence
  getStorageBreakdown: () => api.get('/storage/breakdown'),
  getStorageRecommendations: () => api.get('/storage/recommendations'),
  refreshStorageRecommendations: () => api.post('/storage/recommendations/refresh'),

  // Cron Job Endpoints
  processExpiredRecycleBinItems: () => api.post('/storage/cron/process-expired'),
  sendBlockedUploadDigests: () => api.post('/storage/cron/send-digests'),
};
